import { ResponsiveBar } from "@nivo/bar";
import { useTranslation } from "react-i18next";

import { InvestmentGraphic } from "components/InvestmentGraphicNew";

import { Typography } from "shared/ui/components/Typography";

import styles from "./TaxSavingsAndProfitChart.module.scss";

const _renderInfoPopover = ({ info }: { info: any }) => {
  return (
    <div className={styles.popover}>
      <Typography variant="bodyS" weight="light">
        {info?.section1}
      </Typography>
      {info?.section2 && (
        <Typography
          variant="bodyS"
          weight="light"
          className={styles.popoverSection}
        >
          {info?.section2}
        </Typography>
      )}
    </div>
  );
};

const TaxSavingsAndProfitChart = ({
  variant,
  activePosition,
  investorCashFlowConclusion,
}: {
  variant: string;
  investorCashFlowConclusion: any;
  activePosition: 10 | 20 | 30;
}) => {
  const { t } = useTranslation();

  return (
    <InvestmentGraphic
      variant={variant}
      descriptionVariant={variant}
      title={t("calculator_pro_page.tax_savings_and_profit_chart.title", {
        years: activePosition,
      })}
      price={investorCashFlowConclusion.price}
      caption={investorCashFlowConclusion.caption}
      description={investorCashFlowConclusion.description}
      details={investorCashFlowConclusion.details}
      infoPopover={_renderInfoPopover({
        info: investorCashFlowConclusion.info,
      })}
    >
      <div className={styles.chart}>
        <ResponsiveBar
          data={investorCashFlowConclusion.chartData}
          indexBy="chartItem"
          enableLabel
          enableGridY={false}
          labelSkipWidth={12}
          labelSkipHeight={12}
          axisBottom={null}
          axisLeft={null}
          colors={({ id, data }) => {
            return String(data[`${id}Color`]);
          }}
          labelPosition="end"
          labelOffset={10}
          labelTextColor="#131618"
          label={(labelItem: any) => {
            return labelItem.data.chartItem;
          }}
          tooltip={() => <></>}
          margin={{ top: 15, right: 0, bottom: 0, left: 0 }}
          theme={{
            labels: {
              text: {
                fontSize: 8,
              },
            },
          }}
        />
      </div>
    </InvestmentGraphic>
  );
};

export default TaxSavingsAndProfitChart;
